/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React from 'react';
import { Route } from 'react-router';

import ErrorBoundaryRoutes from 'app/shared/error/error-boundary-routes';

import NutritionPlanIP from './nutrition-plan-ip';
import NutritionPlanIPDetail from './nutrition-plan-ip-detail';
import NutritionPlanIPUpdate from './nutrition-plan-ip-update';
import NutritionPlanIPDeleteDialog from './nutrition-plan-ip-delete-dialog';

const NutritionPlanIPRoutes = () => (
  <ErrorBoundaryRoutes>
    <Route index element={<NutritionPlanIP />} />
    <Route path="new" element={<NutritionPlanIPUpdate />} />
    <Route path=":id">
      <Route index element={<NutritionPlanIPDetail />} />
      <Route path="edit" element={<NutritionPlanIPUpdate />} />
      <Route path="delete" element={<NutritionPlanIPDeleteDialog />} />
    </Route>
  </ErrorBoundaryRoutes>
);

export default NutritionPlanIPRoutes;
